module.exports = __webpack_public_path__ + "img/tactech.5f37e759.png";